/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：809
 */

module.exports = {
  container: "Empty_container__25TbA",
  image: "Empty_image__3vfy2",
  imageOnly: "Empty_imageOnly__1F1Zm",
  imageText: "Empty_imageText__2KmM3",
  text: "Empty_text__2yJWs"
}
